module.exports = __webpack_public_path__ + "img/download.7f300c7e.svg";